import { Box, Button, FormControl, FormControlLabel, FormLabel, LinearProgress, Modal, Radio, RadioGroup, Snackbar, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router';

const SessionModal = ({ sessionMOdalOpen, setSessionMOdalOpen, firstQuaterClick, setFirstQuaterClick, quater_id, seduledata, setSeduledata }) => {

    const router = useRouter()
    const [value, setValue] = React.useState(""); //-----------useState for selection value store

    const [snackbarState, setSnackbarState] = useState(false)
    const [sessionLoader, setSessionLoader] = useState(false);



    // defolt value for firstQuater

    useEffect(() => {
        if (seduledata.schedule_a !== 0) {
            setValue('session_a')
        } else if (seduledata.schedule_b !== 0) {
            setValue('session_b')
        } else if (seduledata.schedule_c !== 0) {
            setValue('session_c')
        }
    }, [seduledata])





    //--------------------handle change for the radio value selection------------------
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    //-----------------main modal close funct--------------------
    const handleCloseModal = () => {
        setSessionMOdalOpen(false)
        setFirstQuaterClick(false)
        setValue("")
        setSeduledata({})
    }

    const handelSubmit = () => {
        if (!value) {
            setSessionLoader(false)
            setSnackbarState(true)
        } else if (quater_id && value) {
            setSessionLoader(true)
            router.push(`/diviner-signup/655498746401a26f70660bce/${quater_id}/${value}`)
            setTimeout(() => {
                handleCloseModal()
            }, 1500);
        }
    }

    //-----------------snackbar close----------------------
    const closeSnack = () => {
        setSnackbarState(false)
    }


    useEffect(() => {
        console.log("seduledata", seduledata);
    }, [seduledata])



    return (
        <>
            <Modal
                open={sessionMOdalOpen}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="banner_modal_main seSSionMOdal">
                <Box className="banner_modal_box">
                    <Typography id="modal-modal-description" component="div" sx={{ mt: 2 }} className="modal_banner">
                        <div className="sub_modal_banner">
                            <span className="close_btn"
                                onClick={handleCloseModal}>
                                <CloseIcon />
                            </span>
                            <div className="sessionMainwrp">
                                <Typography>
                                    <h2>SESSIONS</h2>
                                </Typography>
                                <div className='scheDule_Main'>
                                    <div className='scheduleWrpr'>
                                        <div className='MainTile_wrpr'>
                                            <h3>SCHEDULE A</h3>
                                        </div>
                                        <TableContainer className='sessiontableWrpr'>
                                            <Table sx={{ minWidth: 749 }} aria-label="caption table" >

                                                <TableBody>
                                                    <TableRow >
                                                        <TableCell className="index_column index_cell">Session One Tuesday:</TableCell>
                                                        <TableCell align="right"><span>12:30PM</span> <span>-</span> <span>4:00PM PST</span></TableCell>
                                                        <TableCell align="right"><span>3:30PM</span> <span>-</span> <span>7:00PM EST</span></TableCell>
                                                    </TableRow>

                                                    <TableRow >
                                                        <TableCell className="index_column index_cell">Session One Saturday:</TableCell>
                                                        <TableCell align="right"><span>9:30PM</span> <span>-</span> <span>1:00PM PST</span></TableCell>
                                                        <TableCell align="right"><span>3:30PM</span> <span>-</span> <span>7:00PM EST</span></TableCell>
                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        <FormControl className='radioWrpprBlcok '>
                                            <RadioGroup aria-labelledby="demo-controlled-radio-buttons-group" name="controlled-radio-buttons-group" value={value} onChange={handleChange}>
                                                <FormControlLabel value="session_a" className={(seduledata.schedule_a === 0) ? 'dis_but' : ''} control={<Radio />} disabled={(seduledata.schedule_a === 0) ? true : false} label={`Choose Schedule A (${seduledata.schedule_a === 0 ? 'No Seats Available' : seduledata.schedule_a + ' Seats Available'})`} />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>

                                    {/* {dis_but} */}




                                    <div className='scheduleWrpr'>
                                        <div className='MainTile_wrpr'>
                                            <h3>SCHEDULE B</h3>
                                        </div>
                                        <TableContainer className='sessiontableWrpr'>
                                            <Table sx={{ minWidth: 750 }} aria-label="caption table" >

                                                <TableBody>

                                                    <TableRow >
                                                        <TableCell className="index_column index_cell">Session Two Tuesday:</TableCell>
                                                        <TableCell align="right"><span>4:30PM</span> <span>-</span> <span>8:00PM PST</span></TableCell>
                                                        <TableCell align="right"><span>7:30PM</span> <span>-</span> <span>11:00PM EST</span></TableCell>
                                                    </TableRow>

                                                    <TableRow >
                                                        <TableCell className="index_column index_cell">Session Two Saturday:</TableCell>
                                                        <TableCell align="right"><span>1:30PM</span> <span>-</span> <span>5:00PM PST</span></TableCell>
                                                        <TableCell align="right"><span>7:30PM</span> <span>-</span> <span>11:00PM EST</span></TableCell>
                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        <FormControl className='radioWrpprBlcok'>
                                            <RadioGroup
                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                name="controlled-radio-buttons-group"
                                                value={value}
                                                onChange={handleChange}
                                            >
                                                <FormControlLabel value="session_b" className={(seduledata.schedule_b === 0) ? 'dis_but' : ''} control={<Radio />} disabled={(seduledata.schedule_b === 0) ? true : false} label={`Choose Schedule B (${seduledata.schedule_b === 0 ? 'No Seats Available' : seduledata.schedule_b + ' Seats Available'})`} />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                    <div className='scheduleWrpr'>
                                        <div className='MainTile_wrpr'>
                                            <h3>SCHEDULE C</h3>
                                        </div>
                                        <TableContainer className='sessiontableWrpr'>
                                            <Table sx={{ minWidth: 749 }} aria-label="caption table" >

                                                <TableBody>

                                                    <TableRow >
                                                        <TableCell className="index_column index_cell">Session Three Tuesday:</TableCell>
                                                        <TableCell align="right"><span>4:30 PM</span> <span>-</span> <span>8:00PM PST</span></TableCell>
                                                        <TableCell align="right"><span>7:30PM</span> <span>-</span> <span>11:00PM EST</span></TableCell>
                                                    </TableRow>

                                                    <TableRow >
                                                        <TableCell className="index_column index_cell">Session Three Sunday:</TableCell>
                                                        <TableCell align="right"><span>4:30 PM</span> <span>-</span> <span>8:00PM PST</span></TableCell>
                                                        <TableCell align="right"><span>7:30PM</span> <span>-</span> <span>11:00PM EST</span></TableCell>
                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        <FormControl className='radioWrpprBlcok'>
                                            <RadioGroup
                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                name="controlled-radio-buttons-group"
                                                value={value}
                                                onChange={handleChange}
                                            >
                                                <FormControlLabel value="session_c" className={(seduledata.schedule_c === 0) ? 'dis_but' : ''} control={<Radio />} disabled={(seduledata.schedule_c === 0) ? true : false} label={`Choose Schedule C (${seduledata.schedule_c === 0 ? 'No Seats Available' : seduledata.schedule_c + ' Seats Available'})`} />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </div>
                                <Button className='modal_form_btn' onClick={() => handelSubmit()} ><span>Submit</span></Button>
                                {sessionLoader && (<Box className="loaderProgress" sx={{ width: "100%", mt: "10px", backgroundColor: "#d10001" }}><LinearProgress /></Box>)}
                            </div>
                        </div>
                    </Typography>
                </Box>
            </Modal>
            <Snackbar open={snackbarState} autoHideDuration={3000} onClose={() => closeSnack()} className='snackbarClass' message={"Please choose a schedule to submit"} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
        </>
    )
}

export default SessionModal
